export const emailsFooter = `Correo enviado por
  <a style="color: #6576ff; text-decoration: none" href="https://sttok.com/">sttok.com</a> Puede contactar en <a href="mailto:info@sttok.com" target="_blank">info@sttok.com</a>`;

export const emailsHeader = '';
